import { render } from "./AreaList.vue?vue&type=template&id=e59c4012&scoped=true&ts=true"
import script from "./AreaList.vue?vue&type=script&lang=ts"
export * from "./AreaList.vue?vue&type=script&lang=ts"

import "./AreaList.vue?vue&type=style&index=0&id=e59c4012&lang=scss&scoped=true"
import "./AreaList.vue?vue&type=style&index=1&id=e59c4012&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59c4012"]])

export default __exports__